import { render, staticRenderFns } from "./ConfirmTransactionSignModal.vue?vue&type=template&id=20c75e4b"
import script from "./ConfirmTransactionSignModal.vue?vue&type=script&lang=js"
export * from "./ConfirmTransactionSignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports